import {
  StyledCard,
  StyledCardContent,
  StyledTableBodyRow,
} from "components/CustomCard";
import React from "react";
import "./TableBody.scss";
import { Box, Button, CircularProgress, Typography } from "@material-ui/core";
import { RowProjectTable } from "views/ProjectGroupPage/RightPart/AllProjectTable/constants/Columns";
import Scrollbars from "components/Scrollbars";
import { filter, groupBy, forEach, get, isNil, find } from "lodash";
import { useLocation } from "react-router";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import styled from "styled-components";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import ArrowRightRoundedIcon from "@mui/icons-material/ArrowRightRounded";
import CustomAvatar from "components/CustomAvatar";
import { useTranslation } from "react-i18next";
import { apiService } from "../../../../../constants/axiosInstance";
import {
  SnackbarEmitter,
  SNACKBAR_VARIANT,
} from "../../../../../constants/snackbarController";
import moment from "moment";

function renderTrackVertical({ style, ...props }) {
  const thumbStyle = {
    position: "absolute",
    width: "6px",
    transition: "opacity 200ms ease 0s",
    opacity: 0,
    right: "0",
    bottom: "2px",
    top: "2px",
    borderRadius: "3px",
  };
  return <div style={{ ...style, ...thumbStyle }} {...props} />;
}

const Container = ({ className = "", ...rest }) => (
  <Scrollbars
    className={`view_deleted_project___container ${className}`}
    renderTrackVertical={renderTrackVertical}
    {...rest}
  />
);

export function reorder(list, startIndex, endIndex) {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const StyledTableBodyRowGroup = ({ className = "", children, ...rest }) => (
  <AccordionSummary
    className={`view_deleted_project_comp_CustomTable_TableBodyGroup___row ${className}`}
    {...rest}
  >
    {children}
  </AccordionSummary>
);

const StyledButton = styled(Button)`
  &:hover {
    background: none;
  }
`;

const CustomButton = ({ className = "", ...rest }) => (
  <StyledButton
    className={`view_deleted_project_comp_CustomTable_TableBodyGroup___button ${className}`}
    size="large"
    {...rest}
  />
);

const StyledTableBodyCell = ({ className = "", ...rest }) => (
  <AccordionDetails
    className={`${className}`}
    {...rest}
    sx={{
      backgroundColor: "inherit",
      padding: "0px",
    }}
  />
);

const WPTable = ({ data = [], pendings, handleRestore }) => {
  const [dataRows, setDataRows] = React.useState([]);
  const { t } = useTranslation();

  React.useEffect(() => {
    let tmp = data;
    tmp.sort((a, b) => {
      let aDate = a.delete_at.split("/");
      let bDate = b.delete_at.split("/");
      let strA = `${aDate[1]}/${aDate[0]}/${aDate[2]}`;
      let strB = `${bDate[1]}/${bDate[0]}/${bDate[2]}`;
      console.log(
        strA,
        strB,
        moment("05/03/2021").isBefore(moment("05/02/2021")),
        "sort date"
      );
      return moment(strA).isAfter(moment(strB))
        ? -1
        : moment(strA).isSame(moment(strB))
        ? 0
        : 1;
    });
    setDataRows(tmp);
  }, [data]);

  return (
    <div className="cus_container_deleted_project scrollbar-custom_deleted_project">
      {!!dataRows?.length && (
        <Container autoHide autoHideTimeout={500}>
          <div>
            {dataRows.map((item, index) => {
              return (
                <div className="comp_cus_table_view_project_group_deleted_project">
                  <StyledTableBodyRow>
                    <StyledCard
                      className={`card_cus_row`}
                      style={{ backgroundColor: "white", borderRadius: "20px" }}
                    >
                      <StyledCardContent className="cus_table_row_view_deleted_project">
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <WrapperListMember>
                              <abbr
                                key={index}
                                title={get(item, "user_delete_name", "")}
                              >
                                <div>
                                  <CustomAvatar
                                    style={{ width: 24, height: 24 }}
                                    src={get(item, "user_delete_avatar")}
                                    alt="avatar"
                                  />
                                </div>
                              </abbr>
                            </WrapperListMember>
                            <Typography
                              className={
                                "view_ProjectGroup_Table_All_title_bold"
                              }
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "block",
                                marginLeft: "6px",
                              }}
                            >
                              {get(item, "name", "")}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <WrapperCellName>
                              <Typography
                                className={
                                  "view_ProjectGroup_Table_All_title_bold"
                                }
                                style={{
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  display: "block",
                                }}
                              >
                                Xóa ngày: {get(item, "delete_at", "")}
                              </Typography>
                            </WrapperCellName>
                            <Button
                              disabled={!item?.can_delete_and_restore}
                              variant="text"
                              color="primary"
                              className="cus_btn_setting"
                              onClick={async (e) => {
                                // khôi phục
                                const res = await apiService({
                                  url: "/project/restore-project",
                                  method: "post",
                                  data: {
                                    project_id: item.id,
                                  },
                                });
                                SnackbarEmitter(
                                  SNACKBAR_VARIANT.SUCCESS,
                                  t("DMH.VIEW.PGP.RIGHT.TRASH.BTN.RES_SUCCESS")
                                );
                                handleRestore(
                                  dataRows.filter((e) => e.id !== item.id)
                                );
                              }}
                            >
                              {!isNil(
                                find(
                                  pendings.restorePendings,
                                  (pending) => pending === get(item, "id")
                                )
                              ) && (
                                <CircularProgress
                                  size={16}
                                  className="margin-circular"
                                  color="white"
                                />
                              )}
                              {t("DMH.VIEW.PGP.RIGHT.TRASH.BTN.RES")}
                            </Button>
                            <Button
                              disabled={!item?.can_delete_and_restore}
                              variant="text"
                              color="primary"
                              className="cus_btn_setting"
                              onClick={async (e) => {
                                // khôi phục
                                const res = await apiService({
                                  url: "/project/delete-in-trash",
                                  method: "delete",
                                  data: {
                                    project_id: item.id,
                                  },
                                });
                                SnackbarEmitter(
                                  SNACKBAR_VARIANT.SUCCESS,
                                  t("DMH.VIEW.PGP.RIGHT.TRASH.BTN.DEL_SUCCESS")
                                );
                                handleRestore(
                                  dataRows.filter((e) => e.id !== item.id)
                                );
                              }}
                              style={{
                                color: !item?.can_delete_and_restore
                                  ? "rgba(0, 0, 0, 0.26)"
                                  : "red",
                              }}
                            >
                              {!isNil(
                                find(
                                  pendings.restorePendings,
                                  (pending) => pending === get(item, "id")
                                )
                              ) && (
                                <CircularProgress
                                  size={16}
                                  className="margin-circular"
                                  color="white"
                                />
                              )}
                              {t("DMH.VIEW.PGP.RIGHT.TRASH.BTN.DEL")}
                            </Button>
                          </Box>
                        </Box>
                      </StyledCardContent>
                    </StyledCard>
                  </StyledTableBodyRow>
                </div>
              );
            })}
          </div>
        </Container>
      )}
    </div>
  );
};

const WrapperListMember = styled.div`
  padding: 0px 0px 0px 12px;
  .MuiAvatar-img {
    border-radius: 50%;
  }
`;

const WrapperCellName = styled.div`
  padding: 4px 12px;
  display: flex;
  align-items: center;
  color: #666;
  justify-content: flex-start;

  .drag-icon {
    height: 19.5px;
    position: absolute;
    left: 5px;
  }
  .drag-icon {
    opacity: 0;
  }
  .star-icon {
    opacity: 1;
  }
  .wp-wrapper-button {
    visibility: hidden;
  }

  &:hover {
    .drag-icon {
      opacity: 1;
    }
  }
  .star-icon:hover {
    color: #05b50c;
  }
  a {
    color: #666;
    display: inline-flex;
    margin-left: 8px;
    font-weight: 400 !important;
    &:hover {
      color: #666;
    }
  }
`;

export const scrollbarWidth = () => {
  // thanks too https://davidwalsh.name/detect-scrollbar-width
  const scrollDiv = document.createElement("div");
  scrollDiv.setAttribute(
    "style",
    "width: 100px; height: 100px; overflow: scroll; position:absolute; top:-9999px;"
  );
  document.body.appendChild(scrollDiv);
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
};

export const scrollbarHeight = () => {
  // thanks too https://davidwalsh.name/detect-scrollbar-width
  const scrollDiv = document.createElement("div");
  scrollDiv.setAttribute(
    "style",
    "width: 100px; height: 100px; overflow: scroll; position:absolute; top:-9999px;"
  );
  document.body.appendChild(scrollDiv);
  const scrollbarWidth = scrollDiv.offsetHeight - scrollDiv.clientHeight;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
};

export default WPTable;

const Item = ({ group, pendings }) => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(true);

  return (
    <Accordion
      expanded={open}
      sx={{ boxShadow: "none", backgroundColor: "inherit" }}
    >
      <StyledTableBodyRowGroup
        style={{
          height: "40px",
          minHeight: "40px",
        }}
        onClick={() => {
          setOpen(!open);
        }}
      >
        <CustomButton fullWidth>
          {open ? (
            <ArrowDropDownRoundedIcon fontSize="large" />
          ) : (
            <ArrowRightRoundedIcon fontSize="large" />
          )}
          <div className="cus_item_css">
            {group.projects[0]?.project_group?.name}
          </div>
        </CustomButton>
      </StyledTableBodyRowGroup>
      <StyledTableBodyCell>
        {!!group.projects?.length && (
          <div>
            {group.projects.map((item, index) => {
              return (
                <div className="comp_cus_table_view_project_group_deleted_project">
                  <StyledTableBodyRow>
                    <StyledCard className={`card_cus_row`}>
                      <StyledCardContent className="cus_table_row_view_deleted_project">
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <WrapperListMember>
                              <abbr
                                key={index}
                                title={get(item, "user_delete_name", "")}
                              >
                                <div>
                                  <CustomAvatar
                                    style={{ width: 24, height: 24 }}
                                    src={get(item, "user_delete_avatar")}
                                    alt="avatar"
                                  />
                                </div>
                              </abbr>
                            </WrapperListMember>
                            <Typography
                              className={
                                "view_ProjectGroup_Table_All_title_bold"
                              }
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "block",
                                marginLeft: "6px",
                              }}
                            >
                              {get(item, "name", "")}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <WrapperCellName>
                              <Typography
                                className={
                                  "view_ProjectGroup_Table_All_title_bold"
                                }
                                style={{
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  display: "block",
                                }}
                              >
                                Xóa ngày: {get(item, "delete_at", "")}
                              </Typography>
                            </WrapperCellName>
                            <Button
                              variant="text"
                              color="primary"
                              className="cus_btn_setting"
                              onClick={(e) => {
                                // khôi phục
                              }}
                            >
                              {!isNil(
                                find(
                                  pendings.restorePendings,
                                  (pending) => pending === get(item, "id")
                                )
                              ) && (
                                <CircularProgress
                                  size={16}
                                  className="margin-circular"
                                  color="white"
                                />
                              )}
                              {t("DMH.VIEW.PGP.RIGHT.TRASH.BTN.RES")}
                            </Button>
                          </Box>
                        </Box>
                      </StyledCardContent>
                    </StyledCard>
                  </StyledTableBodyRow>
                </div>
              );
            })}
          </div>
        )}
      </StyledTableBodyCell>
    </Accordion>
  );
};
